"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _order = require("@/api/order");

var _sms = require("@/api/sms");

var _permission = require("@/utils/permission");

var _validate = require("@/utils/validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var validatePhone = function validatePhone(rule, value, callback) {
  if (!value) {
    return callback(new Error('请填写手机号'));
  } else if (!/^1[3456789]\d{9}$/.test(value)) {
    callback(new Error('手机号格式不正确!'));
  } else {
    callback();
  }
};

var _default = {
  name: 'orderSend',
  props: {
    orderId: String
  },
  data: function data() {
    return {
      formItem: {
        type: '1',
        expressRecordType: '1',
        expressId: '',
        expressCode: '',
        deliveryName: '',
        deliveryTel: '',
        // expressName: '',
        expressNumber: '',
        expressTempId: '',
        toAddr: '',
        toName: '',
        toTel: '',
        orderNo: ''
      },
      modals: false,
      express: [],
      exportTempList: [],
      tempImg: '',
      rules: {
        toName: [{
          required: true,
          message: '请输寄件人姓名',
          trigger: 'blur'
        }],
        toTel: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        toAddr: [{
          required: true,
          message: '请输入寄件人地址',
          trigger: 'blur'
        }],
        expressCode: [{
          required: true,
          message: '请选择快递公司',
          trigger: 'change'
        }],
        expressNumber: [{
          required: true,
          message: '请输入快递单号',
          trigger: 'blur'
        }],
        expressTempId: [{
          required: true,
          message: '请选择电子面单',
          trigger: 'change'
        }],
        deliveryName: [{
          required: true,
          message: '请输入送货人姓名',
          trigger: 'blur'
        }],
        deliveryTel: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      },
      expressType: 'normal'
    };
  },
  mounted: function mounted() {},
  methods: {
    checkPermi: _permission.checkPermi,
    // 默认信息
    sheetInfo: function sheetInfo() {
      var _this = this;

      (0, _order.sheetInfoApi)().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.formItem.toAddr = res.exportToAddress || '';
                  _this.formItem.toName = res.exportToName || '';
                  _this.formItem.toTel = res.exportToTel || '';

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 快递公司选择
    onChangeExport: function onChangeExport(val) {
      this.formItem.expressTempId = '';
      if (this.formItem.expressRecordType === '2') this.exportTemp(val);
    },
    // 电子面单模板
    exportTemp: function exportTemp(val) {
      var _this2 = this;

      (0, _sms.exportTempApi)({
        com: val
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
          return _index.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.exportTempList = res.data.data || [];

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    onChangeImg: function onChangeImg(item) {
      var _this3 = this;

      this.exportTempList.map(function (i) {
        if (i.temp_id === item) _this3.tempImg = i.pic;
      });
    },
    changeRadioType: function changeRadioType() {
      this.formItem.expressId = '';
      this.formItem.expressCode = '';
    },
    changeRadio: function changeRadio(o) {
      if (o == 2) {
        this.expressType = 'elec';
      } else {
        this.expressType = 'normal';
      }

      this.formItem.expressId = '';
      this.formItem.expressCode = '';
      this.getList();
    },
    // 物流公司列表
    getList: function getList() {
      var _this4 = this;

      (0, _sms.expressAllApi)({
        type: this.expressType
      }).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
          return _index.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4.express = res;

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // 提交
    putSend: (0, _validate.Debounce)(function (name) {
      var _this5 = this;

      this.formItem.orderNo = this.orderId;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _order.orderSendApi)(_this5.formItem).then(function (async) {
            _this5.$message.success('发送货成功');

            _this5.modals = false;

            _this5.$refs[name].resetFields();

            _this5.$emit('submitFail');
          });
        } else {
          _this5.$message.error('请填写信息');
        }
      });
    }),
    handleClose: function handleClose() {
      this.cancel('formItem');
    },
    cancel: function cancel(name) {
      this.modals = false;
      this.$refs[name].resetFields();
      this.formItem.type = '1';
      this.formItem.expressRecordType = '1';
    }
  }
};
exports.default = _default;